import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Router, useNavigate } from "react-router-dom";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
import MuiButton from "../../../shares/MuiButton";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useUserData } from "../../../../context/UserDataContext";
import PanelTable from "../../../shares/PanelTable";

const AdminReportBangleOnprogressCustomer = () => {
  const navigate = useNavigate();
  const [codeFilter, setCodeFilter] = useState(null);
  const [customerFilter, setCustomerFilterr] = useState(null);

  const headersList = [
    { colName: "bangle_detail", name: "النگو" },
    { colName: "bangle_name", name: "اسم " },

    { colName: "color", name: "رنگ" },
    { colName: "gender", name: "نوع" },
    { colName: "first_name", name: "نام " },
    { colName: "last_name", name: "نام خانوادگی" },
    { colName: "store_name", name: "نام فروشگاه" },
    { colName: "admin_own_accept_size_one_num", name: " ت.یک" },
    { colName: "admin_own_accept_size_two_num", name: "ت.دو" },
    { colName: "admin_own_accept_size_three_num", name: "ت.سه" },
    { colName: "admin_own_accept_size_four_num", name: "ت.چهار" },
    { colName: "admin_own_accept_size_five_num", name: "ت.پنج" },
    { colName: "admin_own_accept_size_six_num", name: "ت.شش" },
  ];

  const mobileHeadersList = [
    { colName: "bangle_detail", name: "النگو" },
    { colName: "bangle_name", name: "اسم " },
    { colName: "color", name: "رنگ" },
    { colName: "gender", name: "نوع" },
    { colName: "first_name", name: "نام " },
    { colName: "last_name", name: "نام خانوادگی" },
    { colName: "store_name", name: "نام فروشگاه" },
    { colName: "admin_own_accept_size_one_num", name: " ت.یک" },
    { colName: "admin_own_accept_size_two_num", name: "ت.دو" },
    { colName: "admin_own_accept_size_three_num", name: "ت.سه" },
    { colName: "admin_own_accept_size_four_num", name: "ت.چهار" },
    { colName: "admin_own_accept_size_five_num", name: "ت.پنج" },
    { colName: "admin_own_accept_size_six_num", name: "ت.شش" },
  ];

  const dataKey = [
    "object.bangle.code",
    "object.bangle.show_name",
    "color",
    "gender",
    "first_name",
    "last_name",
    "store_name",
    "admin_own_accept_size_one_num",
    "admin_own_accept_size_two_num",
    "admin_own_accept_size_three_num",
    "admin_own_accept_size_four_num",
    "admin_own_accept_size_five_num",
    "admin_own_accept_size_six_num",
  ];

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
    // {
    //   type: "textField",
    //   label_fa: "مشتری",
    //   label_en: "customer",
    //   state: customerFilter,
    //   isLTR: true,
    // },
  ];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    getRequestListApi.reFetch();
  };

  const [requestList, setRequestList] = useState([]);

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });
  const { userData } = useUserData();
  const getRequestListApi = useFetch({
    method: "get",
    params: {
      code: fixNumbers(codeFilter),
      customer: customerFilter,
    },
    url: `User_Service/${userData.username}/admin_get_report_bangle_onprogress_customer`,
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const buttonsList = [];

  const actionsList = [];

  const handelPrintReport = () => {
    if (codeFilter !== null)
      navigate(`/print-report-bangle-onprogress-customer/${codeFilter}`);
    else navigate(`/print-report-bangle-onprogress-customer/0`);
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="r-bangle-customer">
        <div className="panel-main-header mt-3 mr-2">
          <span> درخواست مشتریان</span>
        </div>
        <PanelFilter
          header="فیلتر :"
          list={filterList}
          update_filter={update_filter}
          filter={filter}
          reset_filter={reset_filter}
        />
        <div className="flex justify-end">
          <MuiButton
            onClick={handelPrintReport}
            variant="outlined"
            icon={<PrintIcon />}
            color="primary"
            text="چاپ گزارش"
            margin="mr-2"
          />
        </div>
        <PanelTable
          header="لیست مشتریان:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={requestList}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AddShoppingCartIcon />}
          // setSelectedRow={setSelectedRow}
        />
      </PanelTemplate>
    </>
  );
};

export default AdminReportBangleOnprogressCustomer;
